import Swal from 'sweetalert2';
import { openPdfInApp } from './openPdfInApp';

function buildSuccessHtml(response, isPdfResponse, einvoiceConfig) {
  const irn = !isPdfResponse && response?.einvoice_irn;
  const ack = !isPdfResponse && response?.einvoice_ack;
  const backendMessage = !isPdfResponse && response?.message;

  let html = '<p>Invoice saved successfully.</p>';
  if (irn) {
    html += `<p><b>E-Invoice IRN:</b><br/><span style="font-size:12px;word-break:break-all">${irn}</span></p>`;
    if (ack) {
      html += `<p><b>Ack No.:</b> ${ack}</p>`;
    }
    html += '<p style="color:#856404;margin-top:8px;">Edit is locked after IRN is issued.</p>';
  } else if (!isPdfResponse && response?.einvoice_skipped) {
    html += `<p style="color:#0b5ed7;margin-top:8px;">${response.einvoice_skip_reason || response.message || 'Invoice saved as B2C without e-Invoice.'}</p>`;
  } else if (einvoiceConfig?.can_generate_einvoice) {
    html += `<p style="color:#dc3545;margin-top:8px;">E-Invoice IRN was not generated. ${
      backendMessage || 'Check Company GST settings or open the invoice and use Generate E-Invoice.'
    }</p>`;
  } else if (backendMessage && backendMessage !== 'Invoice saved successfully.') {
    html += `<p>${backendMessage}</p>`;
  }
  return { html, irn, savedId: !isPdfResponse ? response?.id : null };
}

export function showInvoiceSaveSuccess({
  response,
  result,
  einvoiceConfig,
  setEinvoiceResult,
  reload,
  printInvoice,
  viewList,
}) {
  const isPdfResponse = response instanceof Blob;
  const { html, irn, savedId } = buildSuccessHtml(response, isPdfResponse, einvoiceConfig);

  if (irn && setEinvoiceResult) {
    setEinvoiceResult(response);
  }

  if (result.isDenied) {
    Swal.fire({ title: 'Success', html, icon: 'success' }).then(() => {
      if (response instanceof Blob) {
        openPdfInApp(response, { title: 'Invoice PDF', onClose: reload });
      } else if (reload) {
        reload();
      }
    });
    return;
  }

  Swal.fire({
    title: 'Success',
    html,
    icon: 'success',
    confirmButtonText: 'OK',
    showDenyButton: Boolean(savedId && printInvoice),
    denyButtonText: 'Print PDF',
    showCancelButton: Boolean(viewList),
    cancelButtonText: 'View List',
  }).then((swalResult) => {
    if (swalResult.isDenied && savedId && printInvoice) {
      printInvoice(savedId);
      return;
    }
    if (swalResult.dismiss === Swal.DismissReason.cancel && viewList) {
      viewList();
      return;
    }
    if (swalResult.isConfirmed && reload) {
      reload();
    }
  });
}
